import { SessionModel, SessionResponse } from 'app/gamma/src/types';
import genericNormalizer, { normalizeDate } from './generic';

export const normalizeSession = genericNormalizer<
  SessionResponse,
  SessionModel
>(({ from, has }) => ({
  dateLastUsed: has('dateLastUsed', normalizeDate),
  id: from('id'),
  ipAddress: from('ipAddress'),
  isCurrent: from('isCurrent'),
}));
